const EMPLOYED_STATUS = ["ROTATION_OFF", "ROTATION_ON"];

export {EMPLOYED_STATUS};
